import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthServiceService } from 'src/app/services/auth-service.service';

@Component({
  selector: 'app-view-comments-dialog',
  templateUrl: './view-comments-dialog.component.html',
  styleUrls: ['./view-comments-dialog.component.css']
})
export class ViewCommentsDialogComponent {
  overallRating = 0;
  rating=0;
  comment:string;
  stars = Array(5).fill(0);
  comments:any[]=[];
  empId:Number;
  title: string;
  public constructor(@Inject(MAT_DIALOG_DATA) public data: any,public _auth:AuthServiceService,public dialogRef:MatDialogRef<ViewCommentsDialogComponent>)
  {
    this.title = data.pocData.title;
    this.empId=this._auth.getEmployeeId();
    this.overallRating=data.pocData.ratingAverage
    var ratingComment= data.pocData.ratingComment.filter(x=>x.empId==this.empId)
    this.rating= ratingComment[0]?.rating ? ratingComment[0]?.rating : 0
    if(data.pocData.ratingComment!=null)
      this.comments=data.pocData.comments.filter(x=>x.comment!=null && x.comment!="").sort((a,b)=>new Date(b.commentOn).getTime()-new Date(a.commentOn).getTime())

    this.AddTimeAgo(this.comments)
  }

  AddTimeAgo(data)
  {
    for(var i=0;i<data.length;i++)
    {
      var timeAgo= this.getTimeAgo(new Date(data[i].commentOn));
      data[i]['timeAgo']=timeAgo;
    }
    this.comments=data
  }
  rate(selectedRating: number) {
    if(selectedRating!=this.rating)
     this.rating = selectedRating;
  }

 save()
 {
   if(this.rating!=0 && (this.comment!=null || this.comment!="" ))
   {
     var data={
       Rating: this.rating,
       Comment: this.comment,
       Status:true
     }
   }
   this.dialogRef.close(data);
 }

  getTimeAgo(createdDate: string | Date): string {
    const created = new Date(createdDate);
    const now = new Date();
    const diffInSeconds = Math.floor((now.getTime() - created.getTime()) / 1000);
  
    if (diffInSeconds < 60) {
      return 'Few seconds ago';
    }
    
    const minutes = Math.floor(diffInSeconds / 60);
    if (minutes < 60) {

      if(minutes==1)
      {
        return `${minutes} minute ago`;
      }
      else{
        return `${minutes} minutes ago`;
      }
    }
    
    const hours = Math.floor(minutes / 60);
    if (hours < 24) {
      if(hours==1)
      {
        return `${hours} hour ago`;
      }
      else{
        return `${hours} hours ago`;
      }
    }
    
    const days = Math.floor(hours / 24);
    if(days==1)
    {
      return `${days} day ago`;
    }
    else{
      return `${days} days ago`;
    }
  }
  
}
